import React from 'react'
import styled from 'styled-components'

const StyledProgress = styled.div`
  display: none;
  max-width: ${(props) => props.fullWidth ? 'none' : '915px'};
  margin: 0 auto;
  width: 100%;

  @media screen and (min-width: 510px) {
    display: block;
  }

  ${(props) =>
    props.animated &&
    `
    @keyframes progressFadeSlide {
      from {
        opacity: 0;
        transform: translateY(-10px);
      }
      to {
        opacity: 1;
        transform: translateY(0);
      }
    }
    animation: progressFadeSlide 0.5s ease 0.3s both;
  `}

  ${(props) =>
    props.dissolving &&
    `
    @keyframes bubbleDissolve {
      from {
        opacity: 1;
        transform: scale(1);
      }
      to {
        opacity: 0;
        transform: scale(0.4);
      }
    }

    ul li:nth-child(1) .bubble-wrapper { animation: bubbleDissolve 0.5s ease-in 0s both; }
    ul li:nth-child(2) .bubble-wrapper { animation: bubbleDissolve 0.5s ease-in 0.25s both; }
    ul li:nth-child(3) .bubble-wrapper { animation: bubbleDissolve 0.5s ease-in 0.5s both; }
    ul li:nth-child(4) .bubble-wrapper { animation: bubbleDissolve 0.5s ease-in 0.75s both; }
  `}

  ul {
    position: relative;
    list-style: none;
    display: flex;
    flex-direction: row;
    width: 100%;
    padding: 10px 30px;
    align-items: flex-start;
    margin: 0;
    background: ${(props) => props.noBackground ? 'none' : 'rgba(0, 0, 0, 0.06)'};
    border-radius: 5px;

    /* line runs from center of first bubble to center of last bubble */
    &:before {
      content: '';
      top: calc(10px + 0.875rem);
      transform: translateY(-50%);
      height: 3px;
      left: calc(30px + 0.875rem);
      width: calc(100% - 60px - 1.75rem);
      position: absolute;
      background: rgba(255, 255, 255, 0.65);
      display: block;
      border-radius: 2px;
    }

    li {
      flex: 1;
      position: relative;
      display: flex;
      flex-direction: column;
      align-items: center;
      font-size: 10px;
      font-weight: 600;
      color: #303030;
      z-index: 1;

      @media screen and (min-width: 480px) {
        font-size: 11px;
      }

      @media screen and (min-width: 768px) {
        font-size: 13px;
      }

      .bubble-wrapper {
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 5px;
        text-align: center;

        /* hide labels in mid-range where they cramp — only bubbles shown */
        @media screen and (min-width: 768px) and (max-width: 1200px) {
          font-size: 0;
          gap: 0;
        }

        &:before {
          content: '';
          height: 1.75rem;
          width: 1.75rem;
          display: flex;
          align-items: center;
          justify-content: center;
          border-radius: 50%;
          background: white;
          border: 2.5px solid rgba(0, 0, 0, 0.12);
          z-index: 1;
          box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
        }
      }

      &.active .bubble-wrapper {
        &:before {
          content: '✓';
          background: ${(props) => props.theme.primaryColor};
          border-color: ${(props) => props.theme.primaryColor};
          color: white;
          font-size: 0.85rem;
          font-weight: 700;
          line-height: 1;
          display: flex;
          align-items: center;
          justify-content: center;
          box-shadow: 0 2px 6px ${(props) => props.theme.primaryColor}55;
        }
      }
    }
  }
`

const ShoppingCartProgress = (props) => {
  return <StyledProgress {...props} className='order-progress-v1' />
}

export default ShoppingCartProgress
